import React, { DragEvent, useState } from 'react';
import './FileUploadBox.scss';
import classNames from 'classnames';

export default function FileUploadBox(props: Props) {
	const [isDragging, setIsDragging] = useState<boolean>(false);

	return (
		<React.Fragment>
			<div className={classNames('file-upload-box__container', { 'file-upload-box__container_dragging': isDragging && !props.isDisabled })}
				 onDrop={handleFilesDropped}
				 onDragOver={handleDragOver}
				 onDragEnter={handleDragEnter}
				 onDragLeave={handleDragLeave}>
				{!props.isDisabled && 
					<React.Fragment>
						<div className="file-upload-box__header">{props.header}</div>
						<div className="text-small text-light mb-3 text-green">{props.subHeader}</div>
						<div>
							<input type="file" className="file-upload-box__input" accept={props.accept} multiple={!props.noMultiple} id="file-upload-box__input_id" onChange={e => handleFilesChanged(e.target)} />
							<label role="button" className="btn btn_secondary file-upload-box__label" htmlFor="file-upload-box__input_id">Browse files</label>
						</div>
					</React.Fragment>
				}
				
				{props.isDisabled && !!props.disabledMessage && 
					<div className="file-upload-box__disabled-message">{props.disabledMessage}</div>
				}
			</div>
		</React.Fragment>
	);

	function handleFilesChanged(elm: HTMLInputElement) {
		if (props.isDisabled)
			return;
		
		if (!elm.files)
			return;

		const files: File[] = [];
		for (let i = 0; i < elm.files.length; i++) {
			files.push(elm.files[i]);
		}
		
		props.onFilesSelected(files);

		// clear out the input. one scenario that requires this
		// is that if you add a file and the remove it and then go 
		// to add it again it wouldn't work because the second time
		// the selected file wouldn't actually change (since it's the
		// same as what was already selected) and the change event
		// wouldn't fire.
		elm.value = '';
	}

	function handleFilesDropped(event: DragEvent) {
		if (props.isDisabled)
			return;
		
		event.preventDefault();
		setIsDragging(false);

		const files: File[] = [],
			dataTransfer = event.dataTransfer;

		if (dataTransfer?.items) {
			for (let i = 0; i < dataTransfer.items.length; i++) {
				const file = dataTransfer.items[i].getAsFile();
				if (file)
					files.push(file);
			}
		} else if (dataTransfer?.files) {
			for (let i = 0; i < dataTransfer.files.length; i++) {
				files.push(dataTransfer.files[i]);
			}
		}

		props.onFilesSelected(files);
	}

	function handleDragEnter(event: DragEvent) {
		event.preventDefault();
		setIsDragging(true);
	}

	function handleDragLeave(event: DragEvent) {
		event.preventDefault();
		setIsDragging(false);
	}

	function handleDragOver(event: DragEvent) {
		event.preventDefault();
		setIsDragging(true);
	}
}

interface Props {
    onFilesSelected: (files: File[]) => void;
    header: string;
    subHeader: string;
    accept: string;
    noMultiple?: boolean;
    isDisabled?: boolean;
    disabledMessage?: string;
}
